module.exports = __webpack_public_path__ + "fonts/proximanova-bold-webfont.d23b93b9.eot";